import React from 'react';
import { observer } from 'mobx-react-lite';
import { HomePageCarouselModelType } from 'src/api/config/home_page_carousel/getHomePageCarousel';
import { HomePageCarouselState } from 'src/AppState/CmsState/HomePageCarouselState/HomePageCarouselState';
import { ListItemPrimary } from 'src/domains/layouts/shared/cms/list/listItems/ListItemPrimary';
import { PromoCarouselItemState } from './PromoCarouselItemState';
import { useAppStateContext } from 'src/AppState/AppState';

interface PromoCarouselPropsType {
    homePageCarouselItem: HomePageCarouselModelType;
    carouselPromoState: HomePageCarouselState;
}

export const PromoCarouselListItem = observer((props: PromoCarouselPropsType) => {
    const { trpcClient } = useAppStateContext();
    const { homePageCarouselItem, carouselPromoState } = props;

    const [itemState] = React.useState(
        () => new PromoCarouselItemState(homePageCarouselItem, carouselPromoState, trpcClient)
    );

    const {
        promoTypeLabel,
        handleDeleteCarousel,
        handleEdit,
        handleDuplicate,
        showDeletePopup,
        handleShowDeletePopup,
        handleHideDeletePopup,
        setActive,
        isEdited,
        isActive,
    } = itemState;

    return (
        <ListItemPrimary
            label={homePageCarouselItem.title}
            startDate={homePageCarouselItem.date_from}
            endDate={homePageCarouselItem.date_to}
            itemType={promoTypeLabel}
            setPublished={setActive}
            isEdited={isEdited}
            isPublished={isActive}
            handleDelete={handleDeleteCarousel}
            handleEdit={handleEdit}
            handleDuplicate={handleDuplicate}
            imgUrl={homePageCarouselItem.img_url ?? ''}
            handleShowDeletePopup={handleShowDeletePopup}
            handleHideDeletePopup={handleHideDeletePopup}
            showDeletePopup={showDeletePopup}
            dataTestLabel='existing-promo-title'
            dataTestItemDescription='banner-label'
            handleDragAndDrop={true}
        />
    );
});
